<template>
    <div class="item-box">
        <!-- item -->
        <div class="item">
            <el-row class="ql-header">
                <el-col :span="12" class="title" v-text="brandText"></el-col>
            </el-row>

            <el-row class="ql-content">
                <el-col :span="12">
                    <div class="content-item">
                        <span class="label">广告主公司名称：</span>
                        <span class="value" v-text="item.company || '--'"></span>
                    </div>
                    <!-- <div class="content-item">
                        <span class="label">直客销售：</span>
                        <span class="value" v-text="item.owner_name || '--'"></span>
                    </div> -->
                </el-col>
                <el-col :span="12">
                    <div class="content-item">
                        <span class="label">编号：</span>
                        <span class="value" v-text="item.customer_id || '--'"></span>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailItemPane',
    computed: {
        brandText () {
            const brandId = this.item.brand || '';
            return (this.brands.find(i => i.id === brandId) || {}).name || '暂无';
        }
    },
    props: {
        item: {
            type: Object,
            required: true,
            default: () => ({})
        },
        brands: {
            type: Array,
            required: true,
            default: () => []
        }
    }
};
</script>

<style lang="less" scoped>
.item {
    position: relative;

    .ql-header {
        padding-bottom: 28px;
        .title {
            color: #303133;
            font-weight: bold;
            font-size: 24px;
            line-height: 36px;
        }
        .ops-btn {
            text-align: right;
        }
    }

    .content-item {
        display: flex;
        .label {
            flex-shrink: 0;
            padding-right: 20px;
            display: inline-block;
            width: 112px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(144, 147, 153, 1);
        }
        .value {
            font-size: 14px;
            font-weight: 500;
            color: rgba(48, 49, 51, 1);

            .tag {
                margin: 0 10px 10px 0;
            }
        }
    }

    .step-content {
        .step-item {
            position: relative;
        }
        .label {
            position: absolute;
            top: 0;
            left: 0;
            display: inline-block;
            font-size: 14px;
            font-weight: 500;
            color: rgba(144, 147, 153, 1);
        }
        .value {
            position: relative;
            padding-left: 132px;
            margin-left: -4%;
        }
    }
}
</style>
